import { Controller } from "@hotwired/stimulus"
import { makeMatcher } from "../utils/text_match"
import consumer from "../channels/consumer"

// Drives the left pane of the intervenant inbox: client-side filter input,
// "new chat" modal opener, and ActionCable subscription that updates
// last-message / unread badge in real time without a page reload.
export default class extends Controller {
  static targets = ["list", "threadPane", "filterInput"]
  static values  = { currentUserId: Number }

  connect() {
    this._subscription = consumer.subscriptions.create(
      { channel: "DiscussionsChannel", user_id: this.currentUserIdValue },
      { received: (data) => this.onReceived(data) }
    )
  }

  disconnect() {
    this._subscription?.unsubscribe()
  }

  // ActionCable fan-out from `BroadcastDiscussionListUpdate` carries the per-
  // user unread_count, so we only act on payloads addressed to us.
  onReceived(data) {
    if (!data || data.user_id !== this.currentUserIdValue) return
    const row = this.listTarget?.querySelector(`[data-discussion-id="${data.discussion_id}"]`)
    if (!row) return

    const preview = row.querySelector(".chat-conversation__preview")
    if (preview && data.last_message != null) {
      preview.textContent = String(data.last_message).slice(0, 60)
    }

    const time = row.querySelector(".chat-conversation__time")
    if (time && data.last_message_updated_at) {
      time.textContent = "à l'instant"
    }

    this._setUnread(row, data.unread_count || 0)

    // Move the row to the top.
    this.listTarget.prepend(row)
  }

  _setUnread(row, count) {
    const bottom = row.querySelector(".chat-conversation__bottom")
    let badge = row.querySelector(".chat-conversation__unread")
    if (count > 0) {
      row.classList.add("is-unread")
      if (badge) {
        badge.textContent = String(count)
      } else if (bottom) {
        badge = document.createElement("span")
        badge.className = "chat-conversation__unread"
        badge.textContent = String(count)
        bottom.appendChild(badge)
      }
    } else {
      row.classList.remove("is-unread")
      badge?.remove()
    }
  }

  filterList() {
    // Recherche par mots : « Olivia Bironneau » retrouve « BIRONNEAU Olivia ».
    const matcher = makeMatcher(this.filterInputTarget.value)
    this.listTarget.querySelectorAll(".chat-conversation").forEach((row) => {
      row.hidden = !matcher(row.dataset.name || "")
    })
  }

  openNewChat() {
    const modal = document.querySelector(".chat-new-modal")
    if (modal) modal.hidden = false
  }
}
